import type { PriceBandRow } from "app/shared/model/EditPricelist";
import { isAnyUnits } from "../priceBands/priceBandsNormalize";
import { PRICELIST_VALIDATION_MESSAGES } from "./pricelistErrorMessages";

const toInt = (x: unknown, fallback: number): number => {
  const n = Number(x);
  return Number.isFinite(n) ? n : fallback;
};

export type PriceBandFieldError = {
  name: string;
  error: string;
};

export function validatePriceBandsForPeriod(
  bands: PriceBandRow[] | undefined,
  productIndex: number,
  periodIndex: number
): PriceBandFieldError[] {
  const errors: PriceBandFieldError[] = [];
  const list = bands ?? [];
  if (list.length < 2) {
    return errors;
  }

  const indexed = list.map((band, pbi) => ({ band, pbi }));
  indexed.sort(
    (a, b) => toInt(a.band.minUnits, 1) - toInt(b.band.minUnits, 1)
  );

  for (let i = 1; i < indexed.length; i++) {
    const prev = indexed[i - 1];
    const cur = indexed[i];
    const prevMax = toInt(prev.band.maxUnits, toInt(prev.band.minUnits, 1));
    const curMin = toInt(cur.band.minUnits, 1);

    if (isAnyUnits(prevMax)) {
      continue;
    }

    if (curMin <= prevMax) {
      errors.push({
        name: `minUnits-${productIndex}-${periodIndex}-${cur.pbi}`,
        error: PRICELIST_VALIDATION_MESSAGES.weekBracketsOverlap,
      });
      errors.push({
        name: `maxUnits-${productIndex}-${periodIndex}-${prev.pbi}`,
        error: PRICELIST_VALIDATION_MESSAGES.weekBracketsOverlap,
      });
      continue;
    }

    if (!isAnyUnits(prevMax) && curMin !== prevMax + 1) {
      errors.push({
        name: `minUnits-${productIndex}-${periodIndex}-${cur.pbi}`,
        error: PRICELIST_VALIDATION_MESSAGES.weekBracketsConsecutive,
      });
      errors.push({
        name: `maxUnits-${productIndex}-${periodIndex}-${prev.pbi}`,
        error: PRICELIST_VALIDATION_MESSAGES.weekBracketsConsecutive,
      });
    }
  }

  return errors;
}

export function isPriceBandFieldErrorName(name: string | undefined): boolean {
  if (!name) return false;
  return (
    name.startsWith("minUnits-") ||
    name.startsWith("maxUnits-")
  );
}